import axiosOverlay from '../../js/axiosOverlay'

const state = {
    actions: null,
    selectedAction: null,
    iCanWrite: [],
    iCantRead: []
};

const getters = {
    actions: state => state.actions,
    selectedAction: state => state.selectedAction,
    iCanWrite: state => state.iCanWrite,
    iCantRead: state => state.iCantRead,
    getActionById: (state) => (actionID) => {
        if (state.actions !== null) {
            return JSON.parse(state.actions)?.find(action => action.id === actionID) ?? null
        }
        return null
    },
    getMyAction: (state, getters, rootState, rootGetters) => {
        let myAction = []
        let allAction = JSON.parse(state.actions)
        if (allAction) {
            allAction.forEach(function(action) {
                let flag = true
                if (action.roleFiltres != null) {
                    rootGetters['user/getRoles'].forEach(function (role) {
                        if (action.roleFiltres.includes(role)) {
                            flag = false
                        }
                    });
                }
                if (flag){
                    myAction.push(action)
                }
            });
        }
        return myAction
    }
};

const mutations = {
    SET_ACTIONS(state, actions) {
        state.actions = actions;
    },
    SET_SELECTED_ACTION(state, action) {
        state.selectedAction = action;
    },
    SET_I_CAN_WRITE(state, list) {
        state.iCanWrite = list;
    },
    SET_I_CANT_READ(state, list) {
        state.iCantRead = list;
    }
};

const actions = {
    async loadActionsFromAPI({ commit, state, rootGetters }) {
        if (state.actions === null) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + "/suivisollicitation/actions",
                headers: { }
            };

            try {
                const response = await axiosOverlay(config);
                let result = JSON.stringify(response.data);
                commit('SET_ACTIONS', result);

                let iCanWrite = [];
                let iCantRead = [];
                let allAction = JSON.parse(result);
                
                allAction.forEach(function (action) {
                    // Remplissage de ce que je peux écrire
                    let flagWrite = true;
                    if (action.roleFiltresWrite != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (action.roleFiltresWrite.includes(role)){
                                flagWrite = false;
                            }
                        });
                    }
                    if (flagWrite) {
                        iCanWrite.push(action);
                    }

                    // Remplissage de ce que je peux lire
                    let flagRead = true;
                    if (action.roleFiltresRead != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (action.roleFiltresRead.includes(role)){
                                flagRead = false;
                            }
                        });
                    }
                    if (!flagRead) {
                        iCantRead.push(action);
                    }
                });
                
                commit('SET_I_CAN_WRITE', iCanWrite);
                commit('SET_I_CANT_READ', iCantRead);
                
            } catch (error) {
                console.log(error);
            }
        }
    },
    
    setSelectedAction({ commit }, actionID) {
        commit('SET_SELECTED_ACTION', actionID);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
